import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';

import { SharedModule } from '../shared/shared.module';
import { AutopartsRoutingModule } from './autoparts-routing.module';
import { PartsSearchComponent } from './components/parts-search';
import { PartsComponent } from './components/parts/parts.component';

@NgModule({
  declarations: [PartsSearchComponent, PartsComponent],
  imports: [
    CommonModule,
    AutopartsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NzImageModule,
    NzGridModule,
    NzListModule,
    NzButtonModule,
    NzCardModule,
    NzLayoutModule,
    NzPaginationModule,
    NzInputModule,
    NzEmptyModule,
    NzTableModule,
    TranslateModule,
    NzDescriptionsModule,
    NzPopconfirmModule,
    NzSelectModule,
    NzSpinModule,
    NzRadioModule,
    SharedModule,
    NzCollapseModule,
    NzBreadCrumbModule,
    NzCheckboxModule,
    NzSwitchModule,
    NzRateModule,
    NzFormModule,
    NzIconModule,
    NzInputNumberModule,
    NzTabsModule,
    NzPageHeaderModule,
    NzAlertModule,
  ],
})
export class AutopartsModule {}
